import { Button } from "@-/dev.improve.haniverse.components.ui.button";
import { Text } from "@-/dev.improve.haniverse.components.ui.text";
import { Image } from "@-/com.npmjs.expo-image";
import { ActivityIndicator } from "@-/com.npmjs.react-native";
import { useTheme } from "@-/dev.improve.haniverse.lib.theme";

const GOOGLE_ICON_SOURCE = { uri: "https://img.clerk.com/static/google.png?width=160" };

export type GoogleSignInButtonProps = {
  compact?: boolean;
  /** Disables the button (e.g. while another auth request is in flight). */
  disabled?: boolean;
  onPress?: () => void;
  /** Shows a spinner and the pending label while Google auth is in flight. */
  pending?: boolean;
};

export function GoogleSignInButton({
  compact = false,
  disabled,
  onPress,
  pending,
}: GoogleSignInButtonProps) {
  const colorScheme = useTheme();
  const iconColor = colorScheme === "dark" ? "white" : "black";

  return (
    <Button
      accessibilityLabel="Sign in with Google"
      accessibilityState={{ busy: pending, disabled }}
      className={
        compact
          ? "h-12 w-full flex-row items-center justify-center gap-3 rounded-xs border-border/60 bg-background sm:h-12"
          : "h-14 w-full flex-row items-center justify-center gap-3 rounded-xs border-border/60 bg-background sm:h-14"
      }
      disabled={disabled}
      onPress={onPress}
      // `sm` keeps the compact padding; the heights above also replace its `sm:h-8`.
      size="sm"
      variant="outline"
    >
      {pending ? (
        <ActivityIndicator color={iconColor} size="small" />
      ) : (
        <Image className="size-5" source={GOOGLE_ICON_SOURCE} />
      )}
      <Text className="text-base font-semibold">
        {pending ? "Signing in with Google…" : "Sign in with Google"}
      </Text>
    </Button>
  );
}
